export default "__VITE_ASSET__Du7XUTNe__"